import Toaster from '@cashew/toaster';
import i18next from 'i18next';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { BRAND_NAME } from '../config/brand';
import Routers from './Routes';

import '../i18n';

const App = () => {
	const user = useSelector((state: any) => state.user);
	const { toasterVisible, toasterTitle, toasterMessage, toasterType } =
		useSelector((state: any) => state.toaster);
	const dispatch = useDispatch();

	let { language } = user;

	if (language !== 'en' && language !== 'ar') {
		language = 'en';
	}

	if (i18next.language !== language) {
		i18next.changeLanguage(language);
	}

	i18next.dir(language);
	if (typeof document !== 'undefined') {
		document
			.getElementsByTagName('html')[0]
			.setAttribute('dir', language === 'ar' ? 'rtl' : 'ltr');
	}

	return (
		<>
			<Helmet
				defaultTitle={`${BRAND_NAME} payments`}
				titleTemplate={`%s - ${BRAND_NAME} payments`}
			>
				<meta
					name="description"
					content="This is the default meta description"
				/>
			</Helmet>
			<Toaster
				title={toasterTitle}
				isVisible={toasterVisible}
				message={toasterMessage}
				type={toasterType}
				onDismiss={() => dispatch({ type: 'TOGGLE_VISIBILITY' })}
			/>
			<Routers />
		</>
	);
};

export default App;
